import VerticalCard from "../verticalCard";


export default function ThreeCardSelection(props) {

    return (
        <section id="" className="ns-stories alignfull">
            <div className="container">
                <section id="stories">

                    <ul>
                        <VerticalCard title={"Free Month Pass"}
                                      subtitle={"Every month, we gift a rising brand with free SEO services, because every shining star deserves her spotlight."}
                                      imageURL={"https://images.pexels.com/photos/7959562/pexels-photo-7959562.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"}
                                      ctaString={"Enter for free"}
                            // imageURL={"https://images.pexels.com/photos/7959763/pexels-photo-7959763.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"}
                                      ctaSource={"/#free-seo"}
                        />

                        <VerticalCard title={"SEO À la Carte"}
                                      subtitle={"Pick exactly what your brand needs, from keyword research to on-page fixes."}
                                      ctaString={"Continue your seo"}
                                      imageURL={"https://images.pexels.com/photos/7222909/pexels-photo-7222909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"}
                                      ctaSource={"/services?source=three-cards-home"}
                        />

                        <VerticalCard title={"Death by Neglect, 2025"}
                                      subtitle={"Competitors don't wait for you to catch up. So here are 20 topics to help take your business to the next level. You run your business. We run circles around the competition stealing your search traffic."}
                                      imageURL={"https://images.pexels.com/photos/7964141/pexels-photo-7964141.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"}
                            // imageURL={"https://images.pexels.com/photos/7925800/pexels-photo-7925800.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"}
                                      ctaSource={"https://toolkit.techstars.com/"}
                                      target="_blank"
                        />
                    </ul>

                </section>
            </div>
        </section>
    )
}